import { render } from "./auditTk.vue?vue&type=template&id=2e3a5026"
import script from "./auditTk.vue?vue&type=script&lang=js"
export * from "./auditTk.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__